import React, { useEffect } from 'react';
import { useWebView } from '../integrations/webview';
import { useTestStore } from '../store/useTestStore';
import { useUserStore } from '../store/useUserStore';
import { useAuthStore } from '../store/useAuthStore';

export const WebViewDebug: React.FC = () => {
  const { isWebView, externalProps, isLoading } = useWebView();
  const { questions, groups } = useTestStore();
  const userInfo = useUserStore((state) => state.userInfo);
  const { accessToken } = useAuthStore();
  
  useEffect(() => {
    console.log('🔍 WebView Debug Info:', {
      isWebView,
      isLoading,
      hasExternalProps: !!externalProps,
      externalPropsKeys: externalProps ? Object.keys(externalProps) : [],
      questionsCount: questions.length,
      groupsCount: groups.length,
      hasUserInfo: !!userInfo,
      hasAccessToken: !!accessToken,
      window: {
        hasWhiteboardExternalProps: !!(window as any).whiteboardExternalProps,
        isWebView: (window as any).isWebView,
        isReactNativeWebView: (window as any).isReactNativeWebView
      }
    });
    
    if (externalProps) {
      console.log('📦 External Props:', JSON.stringify(externalProps, null, 2));
    }
    
    // Check window object
    if ((window as any).whiteboardExternalProps) {
      console.log('🪟 Window Props:', JSON.stringify((window as any).whiteboardExternalProps, null, 2));
    }
  }, [isWebView, externalProps, isLoading, questions, groups, userInfo, accessToken]);
  
  if (!isWebView) {
    return null;
  }
  
  return (
    <div style={{
      position: 'fixed',
      bottom: 20,
      right: 20,
      background: 'rgba(0,0,0,0.8)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999,
      maxWidth: '300px'
    }}>
      <div>WebView: {isWebView ? '✅' : '❌'}</div>
      <div>Loading: {isLoading ? '⏳' : '✅'}</div>
      <div>Props: {externalProps ? '✅' : '❌'}</div>
      <div>Questions: {questions.length}</div>
      <div>Groups: {groups.length}</div>
      <div>User: {userInfo ? '✅' : '❌'}</div>
      <div>Token: {accessToken ? '✅' : '❌'}</div>
    </div>
  );
};